export const downloadIcon =
  'path://M19,16a1,1,0,0,0-1,1v1H6V17a1,1,0,0,0-2,0v2a1,1,0,0,0,1,1H19a1,1,0,0,0,1-1V17A1,1,0,0,0,19,16Z M11.42,14.82A1,1,0,0,0,12,15a1,1,0,0,0,.6-.2l4-3a1,1,0,0,0-1.2-1.6L13,12h0V4a1,1,0,0,0-2,0v8s0,.05,0,.07l-2.43-1.7a1,1,0,0,0-.75-.17,1,1,0,0,0-.65.41A1,1,0,0,0,7.42,12Z';

export const legendIcon = 'path://M0 5h20v15H0V5z';

export const symbolIcon =
  'path://M116.34 75.76C116.34 86.88 107.3 95.92 96.18 95.92C85.05 95.92 76.02 86.88 76.02 75.76C76.02 64.63 85.05 55.6 96.18 55.6C107.3 55.6 116.34 64.63 116.34 75.76Z';
